module.exports = __webpack_public_path__ + "static/media/veidat_hatviot_logo.0d491292.png";